import { Box, FormControl, FormHelperText } from '@mui/material';
import { useTranslation } from 'react-i18next';
import BaseDialog from '@/components/ui/BaseDialog';
import BaseTextField from '@/components/form/BaseTextField';
import useAddApHook, { AP_INPUT_CONFIG } from '@/hooks/registration/useAddApHook';
import { APDialogState, ValidatedMessage } from '@/types/pages/storeManagement/registration';

const AddApDialog = () => {
    const { t } = useTranslation('common');

    const {
        state,
        apState,
        inputRefs,
        hasEditData,
        confirmDisabled,
        closeApDialog,
        resetApDialog,
        handleChange,
        handleValidate,
        isInputDisabled,
        submitApForm,
    } = useAddApHook();

    return (
        <BaseDialog
            dialogTitle={hasEditData ? t('Edit AP') : t('Add AP')}
            open={state.dialogState.isApOpen}
            confirmButtonText={t('Save')}
            cancelButtonText={t('Cancel')}
            disableConfirm={confirmDisabled}
            showSpinnerOnDisable={false}
            onClose={closeApDialog}
            onConfirm={submitApForm}
            TransitionProps={{
                onExited: resetApDialog,
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    gap: 2,
                    py: 1,
                }}
            >
                {AP_INPUT_CONFIG.map((item) => {
                    const value = apState[item.key as keyof APDialogState];
                    const error = apState.validatedMessage[item.key as keyof ValidatedMessage];
                    const hasError = error !== '';

                    return (
                        <FormControl required key={item.id} error={hasError}>
                            <BaseTextField
                                label={t(item.label)}
                                inputRef={(element) => {
                                    inputRefs.current[item.key] = element;
                                }}
                                value={item.format(value)}
                                type={item.type}
                                required
                                placeholder={item.placeholder}
                                slotProps={item.slotProps}
                                error={hasError}
                                disabled={isInputDisabled(item.category)}
                                onChange={(event) => handleChange(event, item.category)}
                                onKeyUp={(event) => handleValidate(event, item.category)}
                            />

                            <FormHelperText
                                error={hasError}
                                sx={{
                                    mx: 0,
                                    mt: 0.5,
                                    minHeight: 18,
                                    fontSize: 12,
                                }}
                            >
                                {error}
                            </FormHelperText>
                        </FormControl>
                    );
                })}
            </Box>
        </BaseDialog>
    );
};

export default AddApDialog;
